import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-component-root',
  imports: [RouterOutlet],
  template: '<router-outlet />',
})
export class AppComponent implements OnInit {
  private readonly translate = inject(TranslateService);

  ngOnInit() {
    const supported = ['en', 'it', 'de'];
    const saved = localStorage.getItem('lang');
    if (saved && supported.includes(saved)) {
      this.translate.use(saved);
      return;
    }

    // Detect browser language, fallback to English
    const browserLang = this.translate.getBrowserLang();
    const lang = browserLang && supported.includes(browserLang) ? browserLang : 'en';
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
  }
}
